import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { isBookMeetingCta, openCalendlyPopup } from '../../helpers/calendlyPopup';

export default function Button({ btnText, btnUrl, variantColor }) {
  const shouldOpenCalendly = isBookMeetingCta(btnText);

  const handleClick = event => {
    if (!shouldOpenCalendly) return;
    event.preventDefault();
    openCalendlyPopup();
  };

  return (
    <Link
      to={btnUrl}
      className={`cs_btn cs_style_1 ${variantColor ? variantColor : ''}`}
      onClick={handleClick}
    >
      {btnText}
      <span>
        <i>
          <Icon icon="fa6-solid:arrow-right" />
        </i>
        <i>
          <Icon icon="fa6-solid:arrow-right" />
        </i>
      </span>
    </Link>
  );
}
